import { Fragment, useCallback, useEffect, useMemo, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { calculateTotalByKey, formatCurrency } from "../../Utility/utility"
import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import { parse } from "@fortawesome/fontawesome-svg-core"
import { useNavigate, } from "react-router-dom"
import { setDetailLotno } from "../../state/stockEntrySlice"
import { toast } from "react-toastify"
import jsPDF from "jspdf"
import { autoTable } from "jspdf-autotable"
import { Button, Checkbox, Select, SelectItem } from "@heroui/react"
import { Box, Chip, Autocomplete, TextField, Typography } from "@mui/material"
import { faCross, faDotCircle, faFile, faFilter, faInfo, faMagnifyingGlass, faXmarkCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { resetDetail } from "../../state/polishSizeSlice";
import { useModalToast } from "../../components/modalToast/ModalToastContext"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { setDate } from "date-fns"


const ParamWisePositionReport = () => {
    const { compCode, compName } = useSelector((state) => state.company);
    const [selDate, setSelDate] = useState({
        fromDate: null,
        toDate: null

    });
    const [isStkAtWise, setIsStkAtWise] = useState(true);
    const [stockType, setStockType] = useState("SNG");
    const [groupType, setGroupType] = useState(
        new Set(["shape"])
    );
    const [selectedLots, setSelectedLots] = useState([]);
    const [selShape, setSelShape] = useState([]);
    const [reportType, setReportType] = useState("");
    const navigate = useNavigate()
    const [selColor, setSelColor] = useState(new Set([]))
    const [selFancyColor, setSelFancyColor] = useState(new Set([]))
    const [selPurity, setSelPurity] = useState(new Set([]))
    const dispatch = useDispatch();
    const { show } = useModalToast()
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const [selectedFilter, setSelectedFilter] = useState({
        shape: [],
        size: [],
        color: [],
        purity: [],
        cut: [],
        polish: [],
        symtry: []
    });

    /* ===================== STYLES ===================== */
    const tableClass = "table-auto border-collapse  border border-gray-700 text-sm min-w-max";
    const headerCell = "border border-gray-700 px-2 py-1 text-center uppercase  font-bold";
    const subHeaderCell = "border border-gray-700 px-2 py-2 font-semibold text-sm text-center bg-gray-100";
    const cellClass = "text-center p-1";

    const stickyFilterCell = "px-0 bg-gray-50 "
    const StickyLeftCellShape =
        "sticky left-0 z-20  font-bold w-[200px]  px-2  shadow-[2px_0_6px_rgba(0,0,0,0.15)]";

    const StickyLeftCellSize =
        "sticky left-[200px] z-20 w-[140px] [background-clip:padding-box]   font-bold px-2  shadow-[2px_0_6px_rgba(0,0,0,0.12)]";

    
    const getStockClass = (type) => STOCK_HEAD_STYLE[type] || "";
    const STOCK_HEAD_STYLE = {
        dynamic:
            "bg-red-100 text-red-700 border-red-200 p-2",
        fixed:
            "bg-emerald-100 text-emerald-900 border-emerald-200",
        mix:
            "bg-blue-100 text-blue-900 border-blue-200",
        total:
            "bg-gradient-to-r from-white to-blue-100 border-1    text-blue-900 font-semibold border-blue-300",
        SaleSng:
            "bg-cyan-50 text-cyan-900 border-cyan-200",
        MemoSng:
            "bg-emerald-100 text-emerald-900 border-emerald-200",
        MemoMix:
            "bg-emerald-100 text-emerald-900 border-emerald-200",
        SaleMix:
            "bg-cyan-50 text-cyan-900 border-cyan-200",
        InwardSng:
            "bg-red-50 text-red-700 border-red-200",
        InwardMix:
            "bg-red-50 text-red-700 border-red-200",
    };
    const STOCK_CELL_STYLE = {
        dynamic:
            "bg-gradient-to-r from-white to-red-50 border-1  text-xs font-semibold text-red-800 border-red-200",
        fixed:
            "bg-gradient-to-r from-white to-emerald-50 border-1 text-xs font-semibold  text-emerald-900 border-emerald-200",
        mix:
            "bg-gradient-to-r from-white to-blue-50  border-1 text-xs font-semibold  text-blue-900 border-blue-200",
        total:
            "bg-gradient-to-r from-white to-blue-100 border-1    text-blue-900 font-semibold border-blue-300",
        SaleSng:
            "bg-gradient-to-r from-white to-cyan-50 border-1 text-xs font-semibold  text-cyan-900 border-cyan-200",
        MemoSng:
            "bg-gradient-to-r from-white to-emerald-50 border-1 text-xs font-semibold  text-emerald-900 border-emerald-200",
        SaleMix:
            "bg-gradient-to-r from-white to-cyan-50 border-1 text-xs font-semibold  text-cyan-900 border-cyan-200",
        MemoMix:
            "bg-gradient-to-r from-white to-emerald-50 border-1 text-xs font-semibold  text-emerald-900 border-emerald-200",
        InwardMix:
            "bg-gradient-to-r from-white to-red-50 border-1 text-xs font-semibold  text-red-900 border-red-200",
        InwardSng:
            "bg-gradient-to-r from-white to-red-50 border-1 text-xs font-semibold  text-red-900 border-red-200",
    };

    const STOCK_BORDER = {
        dynamic: "border-l-2 border-red-200",
        fixed: "border-l-2 border-emerald-200",
        MemoSng: "border-l-2 border-emerald-200",
        SaleSng: "border-l-2 border-cyan-200",
        MemoMix: "border-l-2 border-emerald-200",
        MemoSng: "border-l-2 border-cyan-200",
        mix: "border-l-2 border-blue-200",
        total: "border-l-2 border-blue-500",
    };

    const getStockStyle = (type) => STOCK_CELL_STYLE[type] || "";
    const getStockBorder = (type) => STOCK_BORDER[type] || "";
    const formField = {
        colorCode: "colorCode",
        purityCode: "purityCode",
    }
    /* ===================== FETCH DATA ===================== */
    const { isPending, isError, data = [], mutate: filterData } = usePost({
        url: apiRoute.stockEntry.getParamWiseData,
        queryKey: "ParamwiseDatastck",
    });
    const { data: masterData = [] } = useFetchWithBody({
        url: apiRoute.stockEntry.paramMasterData,
        queryKey: "StockItemMaster",
    })
    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingCurrency",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings
        }
    })


    useEffect(() => {
        let mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting)
        setIsUseMfgNoAsMktno(mktSetting)
    }, [modSetting])

    const funLoadData = (color, purity, action, fromdate, todate) => {

        const getValue = (obj) => { return Array.from(obj).join(",") }
        filterData({
            data: {
                comp_code: compCode.join(","),
                trade_of: "P",
                action: isUseMfgNoAsMktno && action == "INW" ? "STK" : action,
                fdate: fromdate || null,
                tdate: todate || null,
                sha_code: color != "" && color != null ? getValue(color) : null,
                q_code: purity != "" && purity != null ? getValue(purity) : null,
            }
        });
    }

    // useEffect(() => {
    //     funLoadData(null, null)
    // }, [])
    /* ===================== COLUMN CONFIG ===================== */
    const fixedStkAtTypes = ["InwardSng", "InwardMix", "MemoMix", "MemoSng", "SaleMix", "SaleSng"];
    const fixedStkAtHeader = {
        InwardMix: "Inward Mix",
        InwardSng: "Inward Single",
        SaleMix: "Sale Mix",
        SaleSng: "Sale Single",
        "Total Inw": "Total Inward",
        "Total Sale": "Total Sale",
        MemoMix: "ON Memo",
        MemoSng: "ON Memo",
        "MixStock": "Mix Stock",
        "TotalStock": "Total Stock",
        "SingleStock": "Single Stock",

    };

   
    const isTradingView =
        stockType === "SNG" && reportType === "TRND";
    const isInwardView =
        stockType === "SNG" && reportType === "INW";

    const handleFilter = () => {
        if (reportType && reportType != "" && reportType != null)
            funLoadData(selColor, selPurity, reportType, selDate.fromDate, selDate.toDate)
        else
            show("Select Report Type !")
    }
    const visibleFixedCols = useMemo(() => {
        if (stockType === "MIX") return ["MemoMix"];
        if (isTradingView) return ["SaleSng"];
        if (isInwardView) return ["InwardSng", "SaleSng"];
        if (stockType === "SNG") return ["MemoSng"];

        return fixedStkAtTypes;
    }, [stockType, handleFilter]);

    const showDynamicStock = isInwardView ? false : !isTradingView && stockType !== "MIX";
    const showTotalStock = isInwardView && stockType == "SNG" ? false : !isTradingView && stockType !== "MIX";

    const showMixStock = stockType === "MIX";
    // const showDynamicStock =  reportType !== "MIX";
    //  const showTotalStock =  reportType !== "MIX";
    const showTotalsColumns = false // reportType === "BOTH";

    /* ===================== GROUP DATA ===================== */
    const filteredByRptType = useMemo(() => {
        if (stockType === "SNG") {
            return data.filter(item => item.PktType === "SNG");
        }
        if (stockType === "MIX") {
            return data.filter(item => item.PktType === "MIX");
        }
        return data; // BOTH → no filter
    }, [data, stockType]);
    /* ===================== GROUP CONFIG ===================== */


    const groupColumns = useMemo(() => {
        const cols = [];
        if (groupType?.has?.("shape")) cols.push("shape");
        if (groupType?.has?.("size")) cols.push("size");
        if (groupType?.has?.("color")) cols.push("color");
        if (groupType?.has?.("purity")) cols.push("purity");
        if (groupType?.has?.("cut")) cols.push("cut");
        if (groupType?.has?.("polish")) cols.push("polish");
        if (groupType?.has?.("symtry")) cols.push("symtry");


        return cols;
    }, [groupType]);
    /* ===================== COLUMN WIDTHS ===================== */

    const GROUP_COL_WIDTH = {
        shape: 180,
        size: 100,
        color: 100,
        purity: 100,
        cut: 80,
        polish: 80,
        symtry: 80
    };/* ===================== STICKY LEFT ===================== */

    const getStickyLeft = (field) => {
        let left = 0;

        for (const col of groupColumns) {
            if (col === field) break;
            left += GROUP_COL_WIDTH[col];
        }

        return left;
    };

    /* ===================== STICKY CLASS ===================== */

    const getStickyClass = (field) => `
    sticky z-30 bg-blue-500
    border-r border-slate-300
    shadow-[2px_0_6px_rgba(0,0,0,0.12)]

`;

    /* ===================== FILTER STATE ===================== */



    const selectedGroups = useMemo(() => {
        return Array.from(groupType || []);
    }, [groupType]);
    const CurrentGroup = useMemo(() => {

        if (selectedGroups.length === 0)
            return "Group";

        return selectedGroups
            .map((g) => {

                switch (g) {
                    case "shape":
                        return "shape";
                    case "size":
                        return "Size";

                    case "color":
                        return "Color";

                    case "purity":
                        return "Purity";
                    case "cut":
                        return "Cut"
                    case "polish":
                        return "Polish"
                    case "symtry":
                        return "Symtry"

                    default:
                        return g;
                }

            })
            .join(" / ");

    }, [selectedGroups]);
    // ===================== GET GROUP VALUES =====================

    const getGroupValues = (item) => {

        const values = [];

        selectedGroups.forEach((grp) => {

            switch (grp) {
                case "shape":
                    values.push(item?.S_Name || "N/A");
                    break;

                case "size":
                    values.push(item?.ExSize || "N/A");
                    break;

                case "color":
                    values.push(item?.Sh_Name || "N/A");
                    break;

                case "purity":
                    values.push(item?.Q_Name || "N/A");
                    break;

                case "cut":
                    values.push(item?.Cut || "N/A");
                    break;

                case "polish":
                    values.push(item?.Polish || "N/A");
                    break;

                case "symtry":
                    values.push(item?.Symtry || "N/A");
                    break;

                default:
                    break;
            }

        });

        return values;
    };
    /* ===================== DYNAMIC STOCK ===================== */
    const fixColumn = ["Nos", "Weight", "Rate", "S_Rate"]
    const excludedStkAt = [
        "InwardMix",
        "InwardSng",
        "SaleMix",
        "SaleSng",
        "MemoMix", "MemoSng"
    ];

    const dynamicStkAt = useMemo(() => {
        return [...new Set(filteredByRptType.map(d => d.StkAt))]
            .filter(stk => stk && !excludedStkAt.includes(stk));
    }, [filteredByRptType]);
    // ===================== GROUPED DATA =====================

    const groupedData = useMemo(() => {

        const grouped = {};

        /* ================= STEP 1: PRE-SORT DATA ================= */

        const sortedData = [...filteredByRptType].sort((a, b) => {

            const getKeyValue = (item, col) => {
                if (col === "shape") return item?.S_Name || "";
                if (col === "size") return item?.ExSize || "";
                if (col === "color") return item?.Sh_Name || "";
                if (col === "purity") return item?.Q_Name || "";
                if (col === "cut") return item?.Cut || "";
                if (col === "polish") return item?.Polish || "";
                if (col === "symtry") return item?.Symtry || "";
                return "";
            };

            for (let col of groupColumns) {

                const valA = getKeyValue(a, col);
                const valB = getKeyValue(b, col);

                if (valA !== valB) {
                    return valA.localeCompare(valB);
                }
            }

            return 0;
        });

        /* ================= STEP 2: GROUPING ================= */

        sortedData.forEach((item) => {

            const shape = item?.S_Name || "N/A";
            const size = item?.ExSize || "N/A";
            const color = item?.Sh_Name || "N/A";
            const purity = item?.Q_Name || "N/A";
            const cut = item?.Cut || "N/A";
            const polish = item?.Polish || "N/A";
            const symtry = item?.Symtry || "N/A";

            /* ================= FILTER ================= */

            if (
                selectedFilter.shape.length > 0 &&
                !selectedFilter.shape.includes(shape)
            ) return;

            if (
                selectedFilter.size.length > 0 &&
                !selectedFilter.size.includes(size)
            ) return;

            if (
                selectedFilter.color.length > 0 &&
                !selectedFilter.color.includes(color)
            ) return;

            if (
                selectedFilter.purity.length > 0 &&
                !selectedFilter.purity.includes(purity)
            ) return;

            if (
                selectedFilter.cut.length > 0 &&
                !selectedFilter.cut.includes(cut)
            ) return;

            if (
                selectedFilter.polish.length > 0 &&
                !selectedFilter.polish.includes(polish)
            ) return;

            if (
                selectedFilter.symtry.length > 0 &&
                !selectedFilter.symtry.includes(symtry)
            ) return;

            /* ================= DYNAMIC GROUP KEY ================= */

            const groupKeys = {
                shape,
                size,
                color,
                purity,
                cut,
                polish,
                symtry
            };

            const keyParts = groupColumns.map((c) => groupKeys[c]);

            const groupKey = keyParts.join("||");

            if (!grouped[groupKey]) {
                grouped[groupKey] = {
                    groupValues: groupKeys,
                    stock: {},
                };
            }

            const stk = item.StkAt || "N/A";

            if (!grouped[groupKey].stock[stk]) {
                grouped[groupKey].stock[stk] = {
                    Nos: 0,
                    Weight: 0,
                    Rate: 0,
                    S_Rate: 0,
                };
            }

            grouped[groupKey].stock[stk].Nos += Number(item.Nos || 0);
            grouped[groupKey].stock[stk].Weight += Number(item.Weight || 0);
            grouped[groupKey].stock[stk].Rate += Number(item.Rate || 0);
            grouped[groupKey].stock[stk].S_Rate += Number(item.S_Rate || 0);
        });


        /* =========================
   REMOVE FULL ZERO ROWS
========================= */

        const cleanedGrouped = Object.fromEntries(

            Object.entries(grouped).filter(([_, row]) => {

                const stkData = row.stock || {};

                // const allStocks =
                //     [
                //         ...dynamicStkAt,
                //         ...visibleFixedCols,
                //         "MemoMix",
                //         "MemoSng",
                //         //"SaleMix",
                //        // "SaleSng",
                //     ];
                const allStocks = [
                    ...(showDynamicStock ? dynamicStkAt : []),
                    ...visibleFixedCols,
                    ...(showMixStock ? ["InwardMix", "SaleMix"] : [])
                ];

                /* =========================
                   CHECK STOCK ZERO
                ========================= */

                const isZero = (stk) =>
                    fixColumn.every(
                        (col) => Number(stk?.[col] || 0) === 0
                    );

                /* =========================
                   REMOVE IF ALL ZERO
                ========================= */

                const isAllZero = allStocks.every((stk) =>
                    isZero(stkData?.[stk] || {})
                );

                return !isAllZero;
            })

        );

        return stockType == "MIX" ? grouped : cleanedGrouped;

    }, [filteredByRptType, selectedFilter, groupColumns]);



    const columnLabel = {
        shape: "Shape",
        size: "Size",
        color: "Color",
        purity: "Purity",
        cut: "Cut",
        polish: "Polish",
        symtry: "Symtry"
    };

    // ===================== UNIQUE VALUES =====================
    const toUpperUnique = (arr, key) =>
        [...new Set(arr.map(d => d[key]?.toUpperCase()).filter(Boolean))];

    const uniqueValuesMap = useMemo(() => {
        return {
            shape: toUpperUnique(data, "S_Name"),
            size: toUpperUnique(data, "ExSize"),
            color: toUpperUnique(data, "Sh_Name"),
            purity: toUpperUnique(data, "Q_Name"),
            cut: toUpperUnique(data, "Cut"),
            polish: toUpperUnique(data, "Polish"),
            symtry: toUpperUnique(data, "Symtry"),
        };
    }, [data]);

    const getValue = (stkData, stk) => stkData?.[stk] || { Nos: 0, Weight: 0, Rate: 0, S_Rate: 0 };

    /* ===================== GRAND TOTAL ===================== */
    useEffect(() => {
        if (stockType == "" || stockType == null) {
            setStockType("SNG")
        }
    }, [stockType])

    const handleLotSelect = (lotCode) => {
        setSelectedLots((prev) => {
            if (prev.includes(lotCode)) {
                // unselect
                return prev.filter(code => code !== lotCode);
            } else {
                // select
                return [...prev, lotCode];
            }
        });
    };

    const handleLotDetail = () => {
        if (selectedLots && selectedLots.length > 0) {
            dispatch(setDetailLotno(selectedLots))
            navigate(linksUrl.rptLotwiseDetail)
        }
        else {
            toast.error("Select Lot No To Get Info", {
                "position": "top-center"
            })
        }
    }


    const grandTotal = Object.values(groupedData).reduce((accShape, sizeData) => {
        Object.values(sizeData).forEach((stkData) => {
            dynamicStkAt.forEach((stk) => {
                const v = stkData?.[stk] || {};
                accShape.Nos += Number(v.Nos || 0);
                accShape.Weight += Number(v.Weight || 0);
                accShape.Rate += Number(v.Rate || 0);
                accShape.S_Rate += Number(v.S_Rate || 0);
            });
        });

        return accShape;
    }, { Nos: 0, Weight: 0, Rate: 0, S_Rate: 0 });
    const funResetDetail = () => {
        setSelColor(new Set([]));
        setSelPurity(new Set([]));
        setSelDate({ fromDate: null, toDate: null })
        setGroupType(new Set(["shape"]))
        setStockType("SNG")

    }
    const handleResetFilter = () => {
        funResetDetail();
        funLoadData(null, null, reportType, null, null)
    }
    const handleDelet = (key, name) => {
        if (name == 'shape') {
            const newFilter = "selShape"
            newFilter.delete(key)
            setSelShape(new Set(newFilter));
        }
        else if (name == 'color') {
            const newFilter = selColor
            newFilter.delete(key)
            setSelColor(new Set(newFilter));
        }
        else if (name == 'purity') {
            const newFilter = selPurity
            newFilter.delete(key)
            setSelPurity(new Set(newFilter));
        }
        else if (name == 'fancycolor') {
            const newFilter = selFancyColor
            newFilter.delete(key)
            setSelFancyColor(new Set(newFilter));
        }
    }

    const handleRemoveTag = (field, value) => {

        setSelectedFilter((prev) => ({
            ...prev,

            [field]: prev[field].filter(
                (v) => v !== value
            ),
        }));
    };

    const handleViewChange = (e) => {
        setReportType(e.target.value)
        funResetDetail();
        funLoadData(null, null, null, null, null)
    }
    const handleAddSize = () => {
        dispatch(resetDetail())
        window.open(linksUrl.diamondParamater.polishSize.createpolishSizeMaster, "_blank");
    }
    const formatDate = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
    };
    const handleExportExcel = async () => {

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Summary Report");

        /* ================= COLORS ================= */

        const columnColors = {
            dynamic: "E0F2FE",
            fixed: "DCFCE7",
            mix: "FEF3C7",
            total: "FEE2E2",
            inw: "fac780"

        };

        const groupColumnLabels = {
            shape: "Shape",
            size: "Size",
            color: "Color",
            purity: "Purity",
            cut: "Cut",
            polish: "Polish",
            symtry: "Symmetry",
        };

        const dynamicGroupCols = groupColumns;

        const totalStockSources = showDynamicStock
            ? dynamicStkAt
            : [];

        // const stockColumns = [
        //     ...dynamicStkAt,
        //     ...visibleFixedCols,
        //     ...(showMixStock ? ["MixStock"] : []),
        //     ...(showTotalStock ? ["TotalStock"] : []),
        // ];

        const stockColumns = [
            ...(showDynamicStock ? dynamicStkAt : []),
            ...visibleFixedCols,
            ...(showMixStock ? ["MixStock"] : []),
            ...(showTotalStock ? ["TotalStock"] : []),
        ];

        const subCols = ["Pcs", "Weight", "Value (₹)", "Value ($)"];

        /* ================= TITLE ================= */





        const groupLabelMap = {
            shape: "Shape",
            size: "Size",
            color: "Color",
            purity: "Purity",
            cut: "Cut",
            polish: "Polish",
            symtry: "Symmetry",
        };

        const selectedGroupNames = dynamicGroupCols
            .map((key) => groupLabelMap[key] || key)
            .join(" - ");

        const typeLabel =
            reportType === "INW"
                ? "Inward"
                : reportType === "TRND"
                    ? "Trading"
                    : "Stock";
        const dateLabel =
            (selDate?.fromDate ? `From Date: ${formatDate(selDate.fromDate)}` : "") +
            (selDate?.toDate ? ` To Date: ${formatDate(selDate.toDate)}` : "");
        const rptTitle =
            `${selectedGroupNames} Wise ${typeLabel} Summary ${dateLabel}`;
        // const rptTitle = `${selectedGroupNames} Wise ${reportType == "INW" ? "Inward" : reportType == "TRND" ? "Trading" : "Stock"} Summary`;



        const totalExcelCols =
            dynamicGroupCols.length + (stockColumns.length * 4);

        /* ===== COMPANY NAME ===== */

        worksheet.mergeCells(1, 1, 1, totalExcelCols);

        const companyCell = worksheet.getCell(1, 1);
        companyCell.value = compName.join(",") || "";

        companyCell.font = {
            bold: true,
            size: 18, // 🔥 BIG FONT
            color: { argb: "1F2937" }
        };

        companyCell.alignment = {
            horizontal: "center",
            vertical: "middle",
        };

        companyCell.height = 25;

        /* ===== REPORT TITLE ===== */

        worksheet.mergeCells(2, 1, 2, totalExcelCols);

        const titleCell = worksheet.getCell(2, 1);
        titleCell.value = rptTitle;

        titleCell.font = {
            bold: true,
            size: 14, // 🔥 BIG TITLE
            color: { argb: "111827" }
        };

        titleCell.alignment = {
            horizontal: "center",
            vertical: "middle",
        };

        /* ===== EXPORT DATE ===== */

        worksheet.mergeCells(3, 1, 3, totalExcelCols);

        const dateCell = worksheet.getCell(3, 1);
        dateCell.value = `Export Date : ${new Date().toLocaleString()}`;

        dateCell.font = {
            size: 11,
            italic: true,
            color: { argb: "374151" }
        };

        dateCell.alignment = {
            horizontal: "center",
            vertical: "middle",
        };

        /* ===== SPACING ROW ===== */


        /* ================= HEADER STYLE ================= */

        const styleHeader = (cell, bg = "1D4ED8") => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: bg },
            };
            cell.alignment = {
                horizontal: "center",
                vertical: "middle",
                wrapText: true,
            };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
                bottom: { style: "thin" },
            };
        };

        /* ================= HEADER ================= */

        const headerRow1 = 4;
        const headerRow2 = 5;

        let col = 1;

        // GROUP HEADERS
        dynamicGroupCols.forEach((field) => {
            worksheet.mergeCells(headerRow1, col, headerRow2, col);
            const cell = worksheet.getCell(headerRow1, col);
            cell.value = groupColumnLabels[field] || field;
            styleHeader(cell, "2563EB");
            col++;
        });

        // STOCK HEADERS
        stockColumns.forEach((stk) => {

            let bg = "F1F5F9";
            if (dynamicStkAt.includes(stk)) bg = "06B6D4";
            else if (visibleFixedCols.includes(stk) && (stk == "InwardSng" || stk == "InwardMix")) bg = "efa844";
            else if (visibleFixedCols.includes(stk)) bg = "10B981";
            else if (stk === "MixStock") bg = "F59E0B";
            else if (stk === "TotalStock") bg = "EF4444";


            worksheet.mergeCells(headerRow1, col, headerRow1, col + 3);

            const cell = worksheet.getCell(headerRow1, col);
            cell.value = stk;
            styleHeader(cell, bg);

            for (let i = 0; i < 4; i++) {
                const c = worksheet.getCell(headerRow2, col + i);
                c.value = subCols[i];
                styleHeader(c, bg);
            }

            col += 4;
        });

        /* ================= ZERO ROW FILTER (FIXED) ================= */

        // const isZero = (stkData) => {
        //     return fixColumn.every((k) =>
        //         Object.values(stkData || {}).every((s) =>
        //             Number(s?.[k] || 0) === 0
        //         )
        //     );
        // };

        /* ================= BODY ================= */


        let lastGroupValues = {};

        /* =========================
           BODY
        ========================= */

        /* ================= BODY ================= */

        Object.entries(groupedData)

            /* REMOVE ZERO ROWS */
            // .filter(([_, row]) => {

            //     const stkData = row.stock || {};

            //     const allStocks = [
            //         ...dynamicStkAt,
            //         ...visibleFixedCols,
            //         "MemoMix",
            //         "MemoSng",
            //     ];

            //     const isAllZero = allStocks.every((stk) =>
            //         fixColumn.every((k) =>
            //             Number(stkData?.[stk]?.[k] || 0) === 0
            //         )
            //     );

            //     return !isAllZero;
            // })

            .forEach(([_, row]) => {

                const stkData = row.stock;

                const excelRow = [];

                /* =========================
                   GROUP COLUMNS
                ========================= */

                dynamicGroupCols.forEach((field) => {

                    const value =
                        row.groupValues?.[field] || "";

                    // ✅ always show value
                    excelRow.push(value);

                });

                /* =========================
                   STOCK VALUES
                ========================= */

                stockColumns.forEach((stk) => {

                    let values = stkData?.[stk] || {};

                    /* MIX STOCK */

                    if (stk === "MixStock") {

                        values = {
                            Nos:
                                (stkData?.InwardMix?.Nos || 0) -
                                (stkData?.SaleMix?.Nos || 0),

                            Weight:
                                (stkData?.InwardMix?.Weight || 0) -
                                (stkData?.SaleMix?.Weight || 0),

                            Rate:
                                (stkData?.InwardMix?.Rate || 0) -
                                (stkData?.SaleMix?.Rate || 0),

                            S_Rate:
                                (stkData?.InwardMix?.S_Rate || 0) -
                                (stkData?.SaleMix?.S_Rate || 0),
                        };
                    }

                    /* TOTAL STOCK */

                    if (stk === "TotalStock") {

                        values = totalStockSources.reduce(
                            (acc, d) => {

                                const v = stkData?.[d] || {};

                                acc.Nos += Number(v.Nos || 0);
                                acc.Weight += Number(v.Weight || 0);
                                acc.Rate += Number(v.Rate || 0);
                                acc.S_Rate += Number(v.S_Rate || 0);

                                return acc;
                            },
                            {
                                Nos: 0,
                                Weight: 0,
                                Rate: 0,
                                S_Rate: 0,
                            }
                        );
                    }

                    excelRow.push(values.Nos || 0);
                    excelRow.push(values.Weight || 0);
                    excelRow.push(values.Rate || 0);
                    excelRow.push(values.S_Rate || 0);
                });

                /* =========================
                   ADD ROW
                ========================= */

                const addedRow =
                    worksheet.addRow(excelRow);

                /* =========================
                   STYLE ROW
                ========================= */

                addedRow.eachCell((cell, colNumber) => {

                    /* GROUP COLUMNS */

                    if (
                        colNumber <= dynamicGroupCols.length
                    ) {

                        cell.font = {
                            bold: true, // ✅ ONLY GROUP VALUES BOLD
                            color: { argb: "111827" }
                        };

                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: {
                                argb:
                                    colNumber === 1
                                        ? "F3F4F6"
                                        : "DBEAFE",
                            },
                        };

                        cell.alignment = {
                            horizontal: "center",
                            vertical: "middle",
                            wrapText: true,
                        };
                    }

                    /* STOCK COLUMNS */

                    else {

                        const stkIndex =
                            colNumber -
                            dynamicGroupCols.length -
                            1;

                        const stk =
                            stockColumns[
                            Math.floor(stkIndex / 4)
                            ];

                        const type =
                            dynamicStkAt.includes(stk)
                                ? "dynamic"
                                : visibleFixedCols.includes(stk) && (stk == "InwardSng" || stk == "InwardMix") ? "inw"
                                    : visibleFixedCols.includes(stk)
                                        ? "fixed"
                                        : stk === "MixStock"
                                            ? "mix"
                                            : stk === "TotalStock"
                                                ? "total"
                                                : null;

                        cell.font = {
                            bold: false, // ✅ stock normal
                            color: { argb: "111827" }
                        };

                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: {
                                argb:
                                    columnColors[type] ||
                                    "FFFFFF",
                            },
                        };

                        cell.alignment = {
                            horizontal: "center",
                            vertical: "middle",
                        };
                    }

                    /* BORDER */

                    cell.border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        right: { style: "thin" },
                        bottom: { style: "thin" },
                    };
                });
            });
        /* ================= GRAND TOTAL (UNCHANGED LOGIC FIXED ALIGNMENT) ================= */

        const grand = [];

        dynamicGroupCols.forEach((_, i) =>
            grand.push(i === 0 ? "Grand Total" : "")
        );

        stockColumns.forEach((stk) => {
            ["Nos", "Weight", "Rate", "S_Rate"].forEach((k) => {

                let total = 0;

                Object.values(groupedData).forEach((row) => {
                    const stkData = row.stock;

                    if (stk === "MixStock") {
                        total +=
                            (stkData?.InwardMix?.[k] || 0) -
                            (stkData?.SaleMix?.[k] || 0);
                    } else if (stk === "TotalStock") {

                        totalStockSources.forEach((d) => {
                            total += Number(stkData?.[d]?.[k] || 0);
                        });

                    }
                    else {
                        total += Number(stkData?.[stk]?.[k] || 0);
                    }
                });

                grand.push(total);
            });
        });

        const totalRow = worksheet.addRow(grand);

        totalRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "1E40AF" },
            };
            cell.alignment = { horizontal: "center" };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
                bottom: { style: "thin" },
            };
        });

        // worksheet.columns.forEach((c) => (c.width = 14));
        /* =========================
           AUTO COLUMN WIDTH
        ========================= */

        /* =========================
           COLUMN WIDTH
        ========================= */

        worksheet.columns.forEach((column, index) => {

            // default width
            column.width = 14;

            // make only Shape column auto width
            const field = dynamicGroupCols[index];

            if (field === "shape") {

                let maxLength = 20;

                column.eachCell({ includeEmpty: true }, (cell) => {

                    const value =
                        cell.value?.toString() || "";

                    maxLength = Math.max(
                        maxLength,
                        value.length + 2
                    );
                });

                column.width = Math.min(maxLength, 40);
            }
        });
        worksheet.views = [{
            state: "frozen",
            xSplit: dynamicGroupCols.length,
            ySplit: headerRow2,
        }];

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `${rptTitle}.xlsx`);
    };
    
    const handleExportPdf = () => {

        const doc = new jsPDF({
            orientation: "landscape",
            unit: "mm",
            format: "a3",
        });

        const dynamicGroupCols = groupColumns;

        const totalStockSources = showDynamicStock
            ? dynamicStkAt
            : [];

        const stockColumns = [
            ...(showDynamicStock ? dynamicStkAt : []),
            ...visibleFixedCols,
            ...(showMixStock ? ["MixStock"] : []),
            ...(showTotalStock ? ["TotalStock"] : []),
        ];

        const groupLabelMap = {
            shape: "Shape",
            size: "Size",
            color: "Color",
            purity: "Purity",
            cut: "Cut",
            polish: "Polish",
            symtry: "Symmetry",
        };

        const selectedGroupNames = dynamicGroupCols
            .map((key) => groupLabelMap[key] || key)
            .join(" - ");
        const typeLabel =
            reportType === "INW"
                ? "Inward"
                : reportType === "TRND"
                    ? "Trading"
                    : "Stock";
        const dateLabel =
            (selDate?.fromDate ? `From Date: ${formatDate(selDate.fromDate)}` : "") +
            (selDate?.toDate ? ` To Date: ${formatDate(selDate.toDate)}` : "");
        const rptTitle =
            `${selectedGroupNames} Wise ${typeLabel} Summary ${dateLabel}`;

        /* ==========================
           TITLE
        ========================== */

        // doc.setTextColor(25, 55, 109);
        // doc.setFontSize(18);
        // doc.setFont(undefined, "bold");

        // doc.text(
        //     compName.join(", "),
        //     doc.internal.pageSize.width / 2,
        //     14,
        //     { align: "center" }
        // );


        // doc.setTextColor(220, 38, 38);
        // doc.setFontSize(18);

        // doc.text(
        //     rptTitle,
        //     doc.internal.pageSize.width / 2,
        //     24,
        //     { align: "center" }
        // );

        // doc.setTextColor(75, 85, 99);
        // doc.setFontSize(11);
        // doc.setFont(undefined, "normal");


        // doc.text(
        //     `Export Date : ${new Date().toLocaleString()}`,
        //     doc.internal.pageSize.width / 2,
        //     32,
        //     { align: "center" }
        // );

        /* ==========================
           HEADERS
        ========================== */

        const headRow1 = [];
        const headRow2 = [];

        dynamicGroupCols.forEach((field) => {
            headRow1.push(
                groupLabelMap[field] || field
            );

            headRow2.push("");
        });

        stockColumns.forEach((stk) => {

            // MAIN HEADER (merged 4 columns)
            const label = excludedStkAt.includes(stk)
                ? fixedStkAtHeader[stk]
                : stk;
            headRow1.push({
                content: label?.toUpperCase(),
                colSpan: 4,
                styles: {
                    halign: "center",
                    valign: "middle",
                    fontStyle: "bold",
                    fontSize: 11,
                    // fillColor: getStockColor(stk),
                    // textColor: [0, 0, 0],
                    // fillColor: [219, 234, 254],
                    textColor: [30, 64, 175],
                },
            });

            // SUB HEADERS
            headRow2.push(
                { content: "Pcs", styles: { fontStyle: "bold" } },
                { content: "Weight", styles: { fontStyle: "bold" } },
                { content: "Value (RS)", styles: { fontStyle: "bold" } },
                { content: "Value ($)", styles: { fontStyle: "bold" } }
            );
        });

        /* ==========================
           BODY
        ========================== */

        const body = [];

        Object.values(groupedData).forEach((row) => {

            const rowData = [];

            dynamicGroupCols.forEach((field) => {

                rowData.push(
                    row.groupValues?.[field].toUpperCase() || ""
                );
            });

            stockColumns.forEach((stk) => {

                let values =
                    row.stock?.[stk] || {};

                if (stk === "MixStock") {

                    values = {
                        Nos:
                            (row.stock?.InwardMix?.Nos || 0) -
                            (row.stock?.SaleMix?.Nos || 0),

                        Weight:
                            (row.stock?.InwardMix?.Weight || 0) -
                            (row.stock?.SaleMix?.Weight || 0),

                        Rate:
                            (row.stock?.InwardMix?.Rate || 0) -
                            (row.stock?.SaleMix?.Rate || 0),

                        S_Rate:
                            (row.stock?.InwardMix?.S_Rate || 0) -
                            (row.stock?.SaleMix?.S_Rate || 0),
                    };
                }

                if (stk === "TotalStock") {

                    values =
                        totalStockSources.reduce(
                            (acc, d) => {

                                const v =
                                    row.stock?.[d] || {};

                                acc.Nos += Number(v.Nos || 0);
                                acc.Weight += Number(v.Weight || 0);
                                acc.Rate += Number(v.Rate || 0);
                                acc.S_Rate += Number(v.S_Rate || 0);

                                return acc;

                            },
                            {
                                Nos: 0,
                                Weight: 0,
                                Rate: 0,
                                S_Rate: 0,
                            }
                        );
                }

                rowData.push(
                    Number(values.Nos || 0).toLocaleString("en-IN"),

                    Number(values.Weight || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }),

                    Number(values.Rate || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }),

                    Number(values.S_Rate || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })
                );
            });

            body.push(rowData);
        });

        /* ==========================
           GRAND TOTAL
        ========================== */

        const grand = [];

        dynamicGroupCols.forEach((_, i) =>
            grand.push(
                i === 0
                    ? "Grand Total"
                    : ""
            )
        );

        stockColumns.forEach((stk) => {

            ["Nos", "Weight", "Rate", "S_Rate"]
                .forEach((k) => {

                    let total = 0;

                    Object.values(groupedData)
                        .forEach((row) => {

                            const stkData =
                                row.stock;

                            if (
                                stk === "MixStock"
                            ) {

                                total +=
                                    (stkData?.InwardMix?.[k] || 0)
                                    -
                                    (stkData?.SaleMix?.[k] || 0);

                            } else if (
                                stk === "TotalStock"
                            ) {

                                totalStockSources
                                    .forEach((d) => {

                                        total +=
                                            Number(
                                                stkData?.[d]?.[k] || 0
                                            );
                                    });

                            } else {

                                total +=
                                    Number(
                                        stkData?.[stk]?.[k] || 0
                                    );
                            }
                        });

                    if (k === "Nos") {
                        grand.push(Number(total).toLocaleString("en-IN"));
                    } else {
                        grand.push(
                            Number(total).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })
                        );
                    }
                });
        });

        body.push(grand);

        /* ==========================
           TABLE
        ========================== */

        autoTable(doc, {

            startY: 25,

            head: [headRow1, headRow2],

            body,
            showHead: "everyPage",

            styles: {
                fontSize: 9,
                cellPadding: 2,
                halign: "center",
                valign: "middle",
                lineWidth: 0.2,
                textColor: [17, 24, 39],
            },

            headStyles: {
                // fillColor: [37, 99, 235], // Header background
                textColor: [255, 255, 0], // Yellow text
                fontStyle: "bold",
                fontSize: 11,
                cellPadding: 3,
                halign: "center",
                valign: "middle",
            },



            didParseCell(data) {
                if (data.section === "head") {


                    const colIndex = data.column.index;

                    const stkIndex =
                        colIndex - dynamicGroupCols.length;

                    const stk =
                        stockColumns[Math.floor(stkIndex / 4)];

                    // if (stk === "InwardSng" || stk === "InwardMix") {

                    //     data.cell.styles.halign = "center";
                    //     data.cell.styles.valign = "middle";
                    //     data.cell.styles.fontStyle = "bold";
                    //     data.cell.styles.fontSize = 11;

                    //     data.cell.styles.fillColor = [250, 199, 128];
                    //     data.cell.styles.textColor = [0, 0, 0];

                    // }

                    // First Header Row
                    if (data.row.index === 0) {

                        data.cell.styles.fillColor = [59, 130, 246];
                        data.cell.styles.textColor = [255, 255, 255];
                        data.cell.styles.fontSize = 12;
                        data.cell.styles.fontStyle = "bold";
                    }

                    // Second Header Row (Pcs, Weight, Value)
                    if (data.row.index === 1) {

                        data.cell.styles.fillColor = "#f6f7fa";
                        data.cell.styles.textColor = "000000";
                        data.cell.styles.fontSize = 11;
                        data.cell.styles.fontStyle = "bold";
                    }

                    return;
                }

                const rowIndex =
                    data.row.index;

                const colIndex =
                    data.column.index;

                /* GRAND TOTAL */

                if (
                    rowIndex ===
                    body.length - 1
                ) {

                    data.cell.styles.fillColor =
                        [59, 130, 246];

                    data.cell.styles.textColor =
                        [255, 255, 255];

                    data.cell.styles.fontStyle =
                        "bold";
                    data.cell.styles.fontSize = 12;

                    return;
                }

                /* GROUP COLS */

                if (
                    colIndex <
                    dynamicGroupCols.length
                ) {

                    data.cell.styles.fillColor =
                        "ffffff";

                    data.cell.styles.fontStyle =
                        "bold";

                    return;
                }

                /* STOCK COLORS */

                const stkIndex =
                    colIndex -
                    dynamicGroupCols.length;

                const stk =
                    stockColumns[
                    Math.floor(
                        stkIndex / 4
                    )
                    ];

                if (
                    dynamicStkAt.includes(stk)
                ) {

                    data.cell.styles.fillColor =
                        [224, 242, 254];

                } else if (
                    stk === "InwardSng" ||
                    stk === "InwardMix"
                ) {

                    data.cell.styles.fillColor =
                        "fedca6";

                } else if (
                    visibleFixedCols.includes(stk)
                ) {

                    data.cell.styles.fillColor =
                        [220, 252, 231];

                } else if (
                    stk === "MixStock"
                ) {

                    data.cell.styles.fillColor =
                        [254, 243, 199];

                } else if (
                    stk === "TotalStock"
                ) {

                    data.cell.styles.fillColor =
                        [254, 226, 226];
                }
            },
            didDrawPage(data) {
                data.settings.margin.top = 25
                const pageWidth = doc.internal.pageSize.width;
                const pageHeight = doc.internal.pageSize.height;

                const pageCurrent =
                    doc.internal.getCurrentPageInfo().pageNumber;

                const pageCount =
                    doc.internal.getNumberOfPages();

                /* ================= HEADER ================= */

                doc.setFontSize(18);
                // doc.setTextColor(25, 55, 109);
                doc.setFont(undefined, "bold");

                doc.text(
                    compName.join(", "),
                    pageWidth / 2,
                    12,
                    { align: "center" }
                );

                doc.setFontSize(13);
                //doc.setTextColor(220, 38, 38);

                doc.text(
                    rptTitle,
                    pageWidth / 2,
                    20,
                    { align: "center" }
                );

                /* ================= FOOTER ================= */
                const today = new Date().toLocaleDateString("en-GB");
                doc.setFontSize(9);
                doc.text(`Date : ${today}`, pageWidth - 15, 20, { align: "right" });

                const str = `Page ${doc.internal.getNumberOfPages()}`;
                doc.setFontSize(8);
                doc.text(str, pageWidth - 50, pageHeight - 10);
            }
        });

        doc.save(`${rptTitle}.pdf`);
    };
    useEffect(() => {
        if (!groupType || groupType.size === 0) {
            setGroupType(new Set(["shape"])); // default fallback
            //show("Group Type reset to Size (minimum 1 required)");
        }
    }, [groupType]);
    const isZero = (stkData, stk) => {
        const d = stkData?.[stk] || {};
        return fixColumn.every((k) => Number(d?.[k] || 0) === 0);
    }
    const hasAnyFilter = Object.values(selectedFilter).some(
        (v) => Array.isArray(v) && v.length > 0
    );
    if (isPending) {
        return <LoadingCard />
    }
    if (isError) {
        return <ErrorCard />
    }
    return (
        <MainContainer pageName="Shape / Size / Purity Wise Stock Summary" info={[]} breadcrumbs={["Reports", "Stock", "Shape / Size / Purity Wise Stock Summary"]}>
            <div className="bg-white p-2 h-screen">
                <div>

                </div>
                <div className="flex gap-2 flex-wrap sm:flex-nowrap md:flex-nowrap items-center mb-2">
                    <Select
                        selectedKeys={[reportType]}
                        variant="underlined"
                        color="danger"
                        size="sm"
                        label="Report Type"
                        placeholder="--SELECT--"
                        // labelPlacement="outside"
                        onChange={handleViewChange}
                        classNames={{ label: "text-sm text-blue-600 font-bold" }}
                        className=" bg-blue-50 border-0 rounded-md border-blue-400 sm:w-40 md:w-full w-28 border-1"
                    >
                        <SelectItem key="INW">Inward</SelectItem>
                        <SelectItem key="TRND">Trading</SelectItem>
                        <SelectItem key="STK">Stock</SelectItem>
                    </Select>
                    {reportType != "STK" ?
                        <>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"From Date"}
                                    views={["day", "month", "year"]}
                                    size="small"
                                    format="DD/MM/YYYY"
                                    className="w-full"
                                    value={
                                        selDate.fromDate
                                            ? dayjs(selDate.fromDate)
                                            : selDate.fromDate
                                    }
                                    onChange={(newValue) => {
                                        setSelDate((prev) => {
                                            return {
                                                ...prev,
                                                fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"To  Date"}
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    size="small"
                                    className="w-full"
                                    value={
                                        selDate.toDate
                                            ? dayjs(selDate.toDate)
                                            : selDate.toDate
                                    }
                                    onChange={(newValue) => {
                                        setSelDate((prev) => {
                                            return {
                                                ...prev,
                                                toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                        </> :
                        <>
                            <Select
                                size="sm"
                                name={formField.colorCode}
                                label={"Color"}
                                color="default"
                                eventResizeFeature={true}
                                selectionMode="multiple"
                                // labelPlacement="outside"
                                showScrollIndicators={true}
                                placeholder={"--select-"}
                                className="w-full"
                                classNames={{
                                    label: "text-sm font-semibold",
                                }}

                                variant="bordered"
                                isVirtualized
                                items={
                                    masterData && masterData?.colorMaster ? masterData.colorMaster : []
                                }
                                renderValue={(items) => {
                                    return (
                                        <div className="flex gap-2 w-full" >
                                            {items.map((item) => (
                                                <div key={item.Sh_Code} className="flex  text-xs">
                                                    <Chip
                                                        key={item.Sh_Code}
                                                        label={item.data.Sh_Name}
                                                        onDelete={() => handleDelet(item.key, 'color')}
                                                        size="small"
                                                        color="secondary"
                                                        variant="outlined"
                                                        sx={{ height: 22, fontSize: "10px" }}
                                                    />
                                                    {/* <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.S_Code}><strong style={{ fontSize: "0.6rem" }} className=" text-blue-800" > {item.data.S_Name}</strong></Chip>
                                                                    <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'shape')} icon={faCircleXmark} /></div> */}
                                                </div>
                                            ))}
                                        </div>
                                    );
                                }}
                                onSelectionChange={setSelColor}
                                selectedKeys={selColor}
                            >
                                {(list) => (
                                    <SelectItem
                                        key={list.Sh_Code}
                                    >
                                        {list.Sh_Name}
                                    </SelectItem>
                                )}
                            </Select>
                            <Select
                                size="sm"
                                name={formField.purityCode}
                                label={"Purity"}
                                color="default"
                                eventResizeFeature={true}
                                selectionMode="multiple"
                                // labelPlacement="outside"
                                showScrollIndicators={true}
                                placeholder={"--select-"}
                                className="w-full p-0 m-0"
                                classNames={{
                                    label: "text-sm mt-0 pt-0 font-semibold",
                                }}

                                variant="bordered"
                                isVirtualized
                                items={
                                    masterData && masterData?.purityMaster ? masterData.purityMaster : []
                                }
                                renderValue={(items) => {
                                    return (
                                        <div className="flex gap-2 w-full" >
                                            {items.map((item) => (
                                                <div key={item.Q_Code} className="flex  text-xs">
                                                    <Chip
                                                        key={item.Q_Code}
                                                        label={item.data.Q_Name}
                                                        onDelete={() => handleDelet(item.key, 'purity')}
                                                        size="small"
                                                        color="secondary"
                                                        variant="outlined"
                                                        sx={{ height: 22, fontSize: "10px" }}
                                                    />
                                                    {/* <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.S_Code}><strong style={{ fontSize: "0.6rem" }} className=" text-blue-800" > {item.data.S_Name}</strong></Chip>
                                                                    <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'shape')} icon={faCircleXmark} /></div> */}
                                                </div>
                                            ))}
                                        </div>
                                    );
                                }}
                                onSelectionChange={setSelPurity}
                                selectedKeys={selPurity}
                            >
                                {(list) => (
                                    <SelectItem
                                        key={list.Q_Code}
                                    >
                                        {list.Q_Name}
                                    </SelectItem>
                                )}
                            </Select>
                        </>
                    }
                    <div className={`flex gap-4  flex-nowrap   justify-center items-center `}>

                        {/* </div>
                                            <div className={`flex  items-center gap-2 `}> */}
                        <Button
                            size="sm"
                            color="primary"
                            className="bg-blue-600 max-w-28"
                            startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                            onPress={handleFilter}

                        // isLoading={isPending}
                        >
                            Show
                        </Button>
                        <Button
                            style={{ marginLeft: "5px" }}
                            color="primary"
                            size="sm"
                            className="max-w-22 bg-slate-700"
                            startContent={<FontAwesomeIcon icon={faFilter} />}
                            onPress={handleResetFilter}
                        >
                            Reset
                        </Button>
                    </div>
                </div>
                {data && data.length > 0 ?
                    <div className="mb-5">



                        <div className="mb-2 flex flex-wrap sm:flex-nowrap md:flex-nowrap justify-between w-full items-center shadow p-2 gap-x-2 gap-y-2">

                            {/* Left buttons */}


                            {/* Right controls */}
                            <div className="flex flex-nowrap items-center justify-end gap-y-1 gap-x-5">
                                <Select
                                    //selectedKeys={[groupType]}
                                    // variant="flat"
                                    color="danger"
                                    size="sm"
                                    label="View Type : "
                                    labelPlacement="outside"
                                    selectionMode="multiple"
                                    variant={"underlined"}
                                    onSelectionChange={setGroupType}
                                    selectedKeys={groupType}
                                    // onChange={(e) => setGroupType(e.target.value)}
                                    classNames={{ label: "xs text-pink-600" }}
                                    className=" bg-pink-50   border-2 border-pink-600  sm:w-40 md:w-40 w-28 border-1 text-sm font-semibold"
                                >
                                    <SelectItem key="shape"> Shape</SelectItem>
                                    <SelectItem key="size"> Size</SelectItem>
                                    <SelectItem key="purity"> Purity</SelectItem>
                                    <SelectItem key="color"> Color</SelectItem>
                                    <SelectItem key="cut"> Cut</SelectItem>
                                    <SelectItem key="polish"> polish</SelectItem>
                                    <SelectItem key="symtry"> Symtry</SelectItem>
                                </Select>
                                <Select
                                    selectedKeys={[stockType]}
                                    variant="underlined"
                                    color="warning"
                                    size="sm"
                                    label="Stock Type : "
                                    labelPlacement="outside"
                                    onChange={(e) => setStockType(e.target.value)}
                                    classNames={{ label: "xs" }}
                                    className=" bg-amber-50 border-1 border-amber-400 sm:w-40 md:w-40 w-28 border-1 text-sm font-semibold"
                                >

                                    <SelectItem key="MIX">MIX</SelectItem>
                                    <SelectItem key="SNG">SINGLE</SelectItem>
                                </Select>

                            </div>
                            <div className="flex flex-nowrap gap-x-2 gap-y-2 justify-end">
                                <button onClick={handleAddSize} className="text-xs text-blue-700 font-semibold bg-blue-50 rounded-sm p-1 px-2 underline  " >Add Polish Size</button>
                                <button
                                    onClick={handleExportExcel}
                                    className="bg-red-600 text-white whitespace-nowrap h-7 px-3 py-1 rounded text-sm"
                                >
                                    Export Excel
                                </button>
                                <button
                                    onClick={handleExportPdf}
                                    className="bg-green-600 text-white whitespace-nowrap h-7 px-3 py-1 rounded text-sm"
                                >
                                    Export PDF
                                </button>
                            </div>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 8,
                                alignItems: "center",
                                marginBottom: "5px"
                            }}
                        >
                            {hasAnyFilter ? <button onClick={() => setSelectedFilter({
                                shape: [],
                                size: [],
                                color: [],
                                purity: [],
                                cut: [],
                                polish: [],
                                symtry: []
                            })}
                                className="text-orange-500 font-semibold bg-orange-100 text-xs pr-2 rounded-sm shadow-md"
                            ><FontAwesomeIcon className="mr-1 text-md" icon={faXmarkCircle}></FontAwesomeIcon>
                                Clear All</button> : ""}
                            {Object.entries(selectedFilter).map(([field, values]) => {

                                if (!values?.length) return null;

                                return (
                                    <div
                                        key={field}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 6,
                                            flexWrap: "wrap",
                                        }}
                                    >

                                        {/* FIELD LABEL */}
                                        <strong
                                            className="text-xs uppercase text-gray-600"
                                            style={{ fontSize: "0.65rem" }}
                                        >
                                            {field} :
                                        </strong>

                                        {/* CHIPS */}
                                        {values.map((value) => (
                                            <Chip
                                                key={`${field}-${value}`}
                                                label={value}
                                                onDelete={() =>
                                                    handleRemoveTag(field, value)
                                                }
                                                size="small"
                                                color="secondary"
                                                variant="outlined"
                                                sx={{
                                                    height: 22,
                                                    fontSize: "11px",
                                                    borderRadius: "6px",
                                                }}
                                            />
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                        <h2 className="text-blue-700 bg-blue-50  text-left font-bold text-xs uppercase p-2 mb-1">
                            <FontAwesomeIcon icon={faDotCircle} className="mr-2"></FontAwesomeIcon>
                            {reportType == "INW" ? "Inward" : reportType == "TRND" ? "Trading" : "Stock"} Summary</h2>
                        <div className=" border-1  border-slate-300 overflow-auto max-h-[60vh]">
                            <table className="min-w-max border-separate border-spacing-0 text-sm">
                                <thead className="sticky top-0 z-40 bg-gray-100 shadow-md">

                                    <tr className="text-xs uppercase">


                                        {groupColumns.map((field) => (

                                            <th
                                                key={field}
                                                className={`
                        ${getStickyClass(field)}
                        bg-blue-600 text-white
                        border p-2 text-xs uppercase
                    `}
                                                style={{
                                                    left: `${getStickyLeft(field)}px`,
                                                    minWidth: `${GROUP_COL_WIDTH[field]}px`,
                                                }}
                                            >
                                                {columnLabel[field]}
                                            </th>

                                        ))}

                                        {/* DYNAMIC */}
                                        {showDynamicStock &&
                                            dynamicStkAt.map((stk) => (
                                                <th key={stk} colSpan={4} className={`${getStockClass("dynamic", "head")}`}>
                                                    {stk}
                                                </th>
                                            ))
                                        }

                                        {/* FIXED */}
                                        {visibleFixedCols.map((stk) => (
                                            <th key={stk} colSpan={4} className={`${getStockClass(stk)}`}>
                                                {fixedStkAtHeader[stk] || stk}
                                            </th>
                                        ))}

                                        {/* MIX */}
                                        {showMixStock && (
                                            <th colSpan={4} className={`${getStockClass("mix")}`}>
                                                Mix Stock
                                            </th>
                                        )}

                                        {/* TOTAL */}
                                        {showTotalStock && (
                                            <th colSpan={4} className={`${getStockClass("mix")}`}>
                                                Total Stock
                                            </th>
                                        )}
                                    </tr>
                                    <tr className="text-[11px] font-semibold">
                                        {groupColumns.map((field) => (

                                            <th
                                                key={`filter-${field}`}
                                                className={`${getStickyClass(field)} bg-white`}
                                                style={{
                                                    left: `${getStickyLeft(field)}px`,
                                                    width: `${GROUP_COL_WIDTH[field]}px`,
                                                }}
                                            >

                                                <Autocomplete
                                                    multiple
                                                    size="small"
                                                    options={uniqueValuesMap?.[field] || []}
                                                    value={selectedFilter?.[field] || []}

                                                    onChange={(e, value) => {

                                                        setSelectedFilter((prev) => ({
                                                            ...prev,
                                                            [field]: value,
                                                        }));

                                                    }}

                                                    renderTags={() => null}

                                                    noOptionsText="No Data"

                                                    slotProps={{
                                                        chip: {
                                                            size: "small",
                                                            sx: { height: 20, fontSize: "10px", padding: "0 4px", "& .MuiChip-label": { padding: 0 } }
                                                        },
                                                        input: { sx: { padding: "2px 0px !important", fontSize: "11px" } },
                                                        popper: { sx: { fontSize: "12px" } },
                                                        listbox: {
                                                            sx: {
                                                                fontSize: "11px",
                                                                "& .MuiAutocomplete-option": {
                                                                    padding: "2px 8px", minHeight: "28px",
                                                                    "&.Mui-selected": {
                                                                        backgroundColor: "#f3ea6fff !important",
                                                                        color: "#000 !important",
                                                                    },
                                                                    // Change background color when focused via keyboard navigation
                                                                    "&.Mui-focused": {
                                                                        backgroundColor: "rgb(244, 247, 191)",
                                                                    },
                                                                },

                                                            }
                                                        }

                                                    }}

                                                    sx={{
                                                        "& .MuiAutocomplete-inputRoot": {
                                                            padding: "0px 4px !important",
                                                            minHeight: "30px",
                                                            background: "#FFFFFF"
                                                        },

                                                        "& .MuiOutlinedInput-root": {
                                                            padding: "0px !important",
                                                            height: "30px"
                                                        },
                                                    }}

                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Find..."
                                                            variant="outlined"
                                                            size="small"
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                autoComplete: "off"
                                                            }}
                                                            sx={{
                                                                width: "100%",
                                                                "& .MuiInputLabel-root": {
                                                                    fontSize: "10px",
                                                                    color: "#054195",
                                                                    fontWeight: 600
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />

                                            </th>

                                        ))}
                                        {/* SUB HEADER */}
                                        {[
                                            ...(showDynamicStock ? dynamicStkAt : []),
                                            ...visibleFixedCols,
                                            ...(showMixStock ? ["MixStock"] : []),
                                            ...(showTotalStock ? ["TotalStock"] : []),
                                        ].flatMap((col) =>
                                            ["Pcs", "Weight", "Value (₹)", "Value ($)"].map((sub) => (
                                                <th
                                                    key={`${col}-${sub}`}
                                                    className="border p-2 text-xs bg-white text-gray-600"
                                                >
                                                    {sub}
                                                </th>
                                            ))
                                        )}

                                    </tr>
                                </thead>
                                <tbody>

                                    {Object.entries(groupedData)

                                        /* ================= REMOVE ZERO ROWS ================= */
                                        // .filter(([_, row]) => {

                                        //     const stkData = row.stock || {};

                                        //     const allStocks = [
                                        //         ...dynamicStkAt,
                                        //         ...visibleFixedCols,
                                        //         "MemoMix",
                                        //         "MemoSng",
                                        //     ];

                                        //     const isZero = (stk, k) =>
                                        //         fixColumn.every((col) => Number(stk?.[col] || 0) === 0);

                                        //     // remove only if EVERYTHING is zero
                                        //     const isAllZero = allStocks.every((stk) =>
                                        //         isZero(stkData?.[stk] || {})
                                        //     );

                                        //     return !isAllZero;
                                        // })

                                        /* ================= ROWS ================= */
                                        .map(([key, row], index, arr) => {

                                            const stkData = row.stock;

                                            // previous row for group comparison
                                            const prevRow = arr[index - 1]?.[1];

                                            return (
                                                <tr
                                                    key={key}
                                                    className="
            hover:bg-cyan-50
            transition-all
            duration-150
            border-b border-slate-200
          "
                                                >

                                                    {/* ================= GROUP COLUMNS (NO REPEAT) ================= */}
                                                    {groupColumns.map((field, i) => {

                                                        const value = row.groupValues[field];

                                                        let displayValue = value;

                                                        // only apply repeat hide for FIRST GROUP COLUMN (hierarchy style)
                                                        // if (i === 0 && prevRow?.groupValues?.[field] === value) {
                                                        //     displayValue = "";
                                                        // }

                                                        return (
                                                            <td
                                                                key={`${key}-${field}`}
                                                                className={` text-xs ${i == groupColumns.length - 1 ? '  border-r-2 border-r-slate-700' : ""}
                  ${getStickyClass(field)}
                  text-xs font-semibold
                  bg-white border p-2
                `}
                                                                style={{
                                                                    left: `${getStickyLeft(field)}px`,
                                                                    minWidth: `${GROUP_COL_WIDTH[field]}px`,
                                                                    whiteSpace: "normal",   // allow wrap for long shape names
                                                                    wordBreak: "break-word",
                                                                    fontSize: "0.7rem",
                                                                    textTransform: "uppercase"
                                                                }}
                                                            >
                                                                {displayValue}
                                                            </td>
                                                        );
                                                    })}

                                                    {/* ================= DYNAMIC STOCK ================= */}
                                                    {showDynamicStock &&
                                                        dynamicStkAt.flatMap((stk) =>
                                                            fixColumn.map((k) => {

                                                                const value = stkData?.[stk]?.[k] ?? 0;

                                                                return (
                                                                    <td
                                                                        key={`${key}-${stk}-${k}`}
                                                                        className={`${cellClass} ${getStockStyle("dynamic")}`}
                                                                    >
                                                                        {k === "Rate"
                                                                            ? formatCurrency(value)
                                                                            : Number(value).toFixed(2)}
                                                                    </td>
                                                                );
                                                            })
                                                        )
                                                    }

                                                    {/* ================= FIXED STOCK ================= */}
                                                    {visibleFixedCols.flatMap((stk) =>
                                                        fixColumn.map((k) => {

                                                            const value = stkData?.[stk]?.[k] ?? 0;

                                                            return (
                                                                <td
                                                                    key={`${key}-${stk}-${k}`}
                                                                    className={`${cellClass} ${getStockStyle(stk)}`}
                                                                >
                                                                    {k === "Rate"
                                                                        ? formatCurrency(value)
                                                                        : Number(value).toFixed(2)}
                                                                </td>
                                                            );
                                                        })
                                                    )}

                                                    {/* ================= MIX STOCK ================= */}
                                                    {showMixStock &&
                                                        fixColumn.map((k) => {

                                                            const mix =
                                                                (stkData?.InwardMix?.[k] || 0) -
                                                                (stkData?.SaleMix?.[k] || 0);

                                                            return (
                                                                <td
                                                                    key={`${key}-mix-${k}`}
                                                                    className={`${cellClass} ${getStockStyle("mix")}`}
                                                                >
                                                                    {k === "Rate"
                                                                        ? formatCurrency(mix)
                                                                        : Number(mix).toFixed(2)}
                                                                </td>
                                                            );
                                                        })
                                                    }

                                                    {/* ================= TOTAL STOCK ================= */}
                                                    {showTotalStock &&
                                                        fixColumn.map((k) => {

                                                            const total = dynamicStkAt.reduce((acc, stk) => {
                                                                acc += Number(stkData?.[stk]?.[k] || 0);
                                                                return acc;
                                                            }, 0);

                                                            return (
                                                                <td
                                                                    key={`${key}-total-${k}`}
                                                                    className={`
                    ${cellClass}
                    ${getStockStyle("total")}
                    font-bold
                  `}
                                                                >
                                                                    {k === "Rate"
                                                                        ? formatCurrency(total)
                                                                        : Number(total).toFixed(2)}
                                                                </td>
                                                            );
                                                        })
                                                    }

                                                </tr>
                                            );
                                        })}

                                </tbody>
                                <tr className="sticky bottom-0 z-50 bg-white  text-gray-900 font-bold  border-t-2 border-gray-500 shadow-[2px_0_6px_rgba(0,0,0,0.12)]">
                                    {groupColumns.map((field, index) => (

                                        <td
                                            key={`footer-${field}`}
                                            className={`
                                                ${getStickyClass(field)}
                                                bg-blue-600 text-white
                                                border p-2 text-xs font-bold
                                            `}
                                            style={{
                                                left: `${getStickyLeft(field)}px`,
                                                minWidth: `${GROUP_COL_WIDTH[field]}px`,
                                            }}
                                        >
                                            {index === 0 ? "GRAND TOTAL" : ""}
                                        </td>

                                    ))}

                                    {/* DYNAMIC */}
                                    {showDynamicStock &&
                                        dynamicStkAt.flatMap((stk) =>
                                            fixColumn.map((k) => {
                                                const total = Object.values(groupedData).reduce((acc, sizeData) => {
                                                    Object.values(sizeData).forEach((stkData) => {
                                                        const v = stkData?.[stk] || {};
                                                        acc += Number(v[k] || 0);
                                                    });
                                                    return acc;
                                                }, 0);

                                                return (
                                                    <td key={`gt-${stk}-${k}`} className={`text-center border p-2 ${getStockClass("dynamic", "head")} bg-white`}>
                                                        {k === "Rate"
                                                            ? formatCurrency(total)
                                                            : total.toFixed(2)}
                                                    </td>
                                                );
                                            })
                                        )}

                                    {/* FIXED */}
                                    {visibleFixedCols.flatMap((stk) =>
                                        fixColumn.map((k) => {
                                            const total = Object.values(groupedData).reduce((acc, sizeData) => {
                                                Object.values(sizeData).forEach((stkData) => {
                                                    const v = stkData?.[stk] || {};
                                                    acc += Number(v[k] || 0);
                                                });
                                                return acc;
                                            }, 0);

                                            return (
                                                <td key={`gt-fixed-${stk}-${k}`} className={`text-center border ${getStockClass(stk)} bg-white`}>
                                                    {k === "Rate"
                                                        ? formatCurrency(total)
                                                        : total.toFixed(2)}
                                                </td>
                                            );
                                        })
                                    )}

                                    {/* MIX */}
                                    {showMixStock &&
                                        fixColumn.map((k) => {
                                            const total = Object.values(groupedData).reduce((acc, sizeData) => {
                                                Object.values(sizeData).forEach((stkData) => {
                                                    const v1 = stkData?.InwardMix?.[k] || 0;
                                                    const v2 = stkData?.SaleMix?.[k] || 0;
                                                    acc += (v1 - v2);
                                                });
                                                return acc;
                                            }, 0);

                                            return (
                                                <td key={`gt-mix-${k}`} className={`text-center border ${getStockClass("mix")} bg-white`}>
                                                    {k === "Rate"
                                                        ? formatCurrency(total)
                                                        : total.toFixed(2)}
                                                </td>
                                            );
                                        })
                                    }

                                    {/* TOTAL */}

                                    {showTotalStock && fixColumn.map((k) => (
                                        <td key={`gt-total-${k}`} className={`text-center border font-bold ${getStockClass("mix")} bg-white`}>
                                            {k === "Rate"
                                                ? formatCurrency(grandTotal[k])
                                                : grandTotal[k].toFixed(2)}
                                        </td>
                                    ))}
                                </tr>
                            </table>
                        </div>
                    </div> :
                    <Box sx={{
                        p: 4,
                        textAlign: 'center',
                        border: `1px dashed gray`,
                        borderRadius: 2,
                        backgroundColor: 'background.default'

                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2
                        }}>
                            <FontAwesomeIcon icon={faInfo} />
                            {/* <DescriptionOutlined sx={{
                                  fontSize: 48,
                                  color: 'text.disabled'
                                }} /> */}
                            <Typography variant="h6" color="text.secondary">
                                No  data available
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Apply filters above to generate a report
                            </Typography>
                        </Box>
                    </Box>}
            </div>
        </MainContainer>
    );
};

export default ParamWisePositionReport

